<template>
  <base-dialog-component
    :showClose="false"
    :open="open"
    :body="$t(`welcomeBody${lab}`)"
    optionType="vertical"
    :options="options"
    @selectOption="closeWelcome"
    height="auto"
    width="50vw"
    maxWidth="485px"
    paddingText="0px 34px 10px"
    :top="top"
    :bottom="bottom"
    :right="right"
    :overlay="true"
    overlayColor="transparent"
    :centerVertical="true"
    :center="false"
    :showBubble="true"
  ></base-dialog-component>
</template>
<script>
import { calculatePixel, securePlayer, setCamera } from "@/scenes/MyFirstScene";
import baseComponent from "./baseComponent.vue";

export default {
  name: "WelcomeComponent",
  components: {
    baseDialogComponent: baseComponent,
  },
  data() {
    return {
      open: false,
      options: [
        {
          title: "welcomeOptionSelectProduct",
          key: "selectProduct",
        },
      ],
      bottom: null,
      top: null,
      right: null,
    };
  },
  computed: {
    lab() {
      return this.$store.getters.getCurrentLab;
    },
  },
  beforeMount() {
    this.$root.$on("openWelcome", this.openWelcome);
  },
  beforeDestroy() {
    this.$root.$off("openWelcome", this.openWelcome);
  },
  methods: {
    async openWelcome() {
      await securePlayer(true, "welcome");

      setCamera("Welcome");

      setTimeout(() => {
        const { minX, minY } = calculatePixel("Wolf3D_Teeth.001");

        const top = minY;
        const right = window.innerWidth - minX + 40;

        this.top = `calc(${top}px)`;
        this.right = `calc(${right}px)`;

        this.open = true;
      }, 100);
    },
    async closeWelcome({ option }) {
      let result;
      switch (option.key) {
        case "tour":
          this.open = false;
          await new Promise((resolve) => {
            this.$root.$emit("dispatchAction", { cta: "aerialView", resolve });
          });
          this.options[0].style = {
            filter:
              "invert(55%) sepia(13%) saturate(0%) hue-rotate(144deg) brightness(93%) contrast(93%)",
          };

          this.open = true;
          break;
        case "selectProduct":
          this.open = false;

          result = await new Promise((resolve) => {
            this.$root.$emit("dispatchAction", {
              cta: "product",
              resolve,
            });
          });

          if (result) {
            this.$root.$emit("openAfterWelcome");
          } else {
            this.openWelcome();
          }
          break;

        default:
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
